import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "@/lib/api";
import { toast } from "sonner";
import { Check, ArrowLeft, Loader2 } from "lucide-react";
import { Logo } from "@/components/Logo";

const PLANS = [
  { lookup_key: "essentiel_monthly", name: "Essentiel", price: "10 €", period: "/mois", testid: "pricing-plan-essentiel-button",
    feats: ["Programme 4 semaines", "Plan alimentaire", "Export PDF", "Suivi + arbre animé", "Coach IA"] },
  { lookup_key: "premium_monthly", name: "Premium", price: "17 €", period: "/mois", highlight: true, testid: "pricing-plan-premium-button",
    feats: ["Tout Essentiel", "Coach IA illimité", "Bilans bi-mensuels", "Priorité nouveautés"] },
  { lookup_key: "annuel_yearly", name: "Annuel", price: "170 €", period: "/an", testid: "pricing-plan-annuel-button",
    feats: ["Tout Premium", "2 mois offerts", "Meilleur prix"] },
];

export default function Pricing() {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(null);

  const checkout = async (lookup_key) => {
    setBusy(lookup_key);
    try {
      const { data } = await apiClient.post("/payments/checkout", {
        lookup_key, origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err.response?.data?.detail || "Impossible de démarrer le paiement.");
      setBusy(null);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0F0D] text-white px-5 py-8">
      <div className="max-w-md mx-auto sm:max-w-4xl">
        <button onClick={() => navigate("/app")} className="flex items-center gap-2 text-sm text-white/60 mb-6 hover:text-white">
          <ArrowLeft className="h-4 w-4" /> Retour
        </button>
        <div className="mb-3">
          <Logo size="sm" />
        </div>
        <h1 className="font-display text-3xl font-black mb-2">Choisis ta formule</h1>
        <p className="text-white/50 text-sm mb-6">Débloque ton programme personnalisé. Sans engagement, résiliable à tout moment.</p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {PLANS.map((p) => (
            <div key={p.lookup_key} className={`rounded-2xl p-6 border ${p.highlight ? "border-lime-400/60 bg-lime-400/[0.06]" : "border-white/10 bg-[#141C17]"}`}>
              {p.highlight && <span className="text-xs font-bold text-lime-400">RECOMMANDÉ</span>}
              <h3 className="font-display text-xl font-bold mt-1">{p.name}</h3>
              <div className="mt-2 mb-5"><span className="text-3xl font-black">{p.price}</span><span className="text-white/50 text-sm">{p.period}</span></div>
              <ul className="space-y-2 mb-6">
                {p.feats.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-sm text-gray-300">
                    <Check className="h-4 w-4 text-lime-400 shrink-0" /> {f}
                  </li>
                ))}
              </ul>
              <button data-testid={p.testid} onClick={() => checkout(p.lookup_key)} disabled={busy === p.lookup_key}
                className={`w-full font-extrabold py-3 rounded-xl active:scale-95 transition-all disabled:opacity-60 ${p.highlight ? "bg-lime-400 text-black hover:bg-[#b0e600]" : "bg-white/10 text-white hover:bg-white/15"}`}>
                {busy === p.lookup_key ? <Loader2 className="h-4 w-4 animate-spin mx-auto" /> : "Choisir"}
              </button>
            </div>
          ))}
        </div>
        <p className="text-center text-xs text-white/30 mt-8">Paiement sécurisé par Stripe</p>
      </div>
    </div>
  );
}
